import { IDepartment, IDistrict, ILocation, ILookup, IMunicipality, IProgramme, ISector } from "../../app/modules/core/_models";
import { StoreAction } from "../../utils/actions";

/** State type */
interface masterDataState {
    departmentsData: IDepartment[];
    sectorsData: ISector[];
    prioritiesData: ILookup[];
    projectTypesData: ILookup[];
    actionProjectTypesData: ILookup[];
    jurisdictionData: ILookup[];
    districtData: IDistrict[];
    municipalityData: IMunicipality[];
    locationData: ILocation[];
    programmesData: IProgramme[];
    idmsProjectStageData: ILookup[];

    //  For loading Data
    isDepartmentsDataLoading: boolean;
    isSectorsDataLoading: boolean;
    isPrioritiesDataLoading: boolean;
    isProjectTypesDataLoading: boolean;
    isActionProjectTypesDataLoading: boolean;
    isJurisdictionDataLoading: boolean;
    isDistrictDataLoading: boolean;
    isMunicipalityDataLoading: boolean;
    isLocationDataLoading: boolean;
    isProgrammesDataLoading: boolean;
    isIdmsProjectStageDataLoading: boolean;
}

/** Action type */
interface masterDataAction {
    type: string;
    payload: IDepartment[] | ISector[] | ILookup[] | ILocation[] | IProgramme[] | IMunicipality[] | IDistrict[]
}

const initialState: masterDataState = {
    departmentsData: [],
    sectorsData: [],
    prioritiesData: [],
    projectTypesData: [],
    actionProjectTypesData: [],
    jurisdictionData: [],
    districtData: [],
    municipalityData: [],
    locationData: [],
    programmesData: [],
    idmsProjectStageData: [],

    //  For loading Data
    isDepartmentsDataLoading: false,
    isSectorsDataLoading: false,
    isPrioritiesDataLoading: false,
    isProjectTypesDataLoading: false,
    isActionProjectTypesDataLoading: false,
    isJurisdictionDataLoading: false,
    isDistrictDataLoading: false,
    isMunicipalityDataLoading: false,
    isLocationDataLoading: false,
    isProgrammesDataLoading: false,
    isIdmsProjectStageDataLoading: false
};

export default function masterDataReducer(
    state: masterDataState = initialState,
    action: masterDataAction
): masterDataState {

    switch (action.type) {

        //  Replace full Department list
        case StoreAction.DEPARTMENTS_DATA:
            return {
                ...state,
                departmentsData: action.payload as IDepartment[],
                isDepartmentsDataLoading: true
            };

        //  Replace full Sector list
        case StoreAction.SECTORS_DATA:
            return {
                ...state,
                sectorsData: action.payload as ISector[],
                isSectorsDataLoading: true
            };

        //  Replace full Priority list
        case StoreAction.PRIORITIES_DATA:
            return {
                ...state,
                prioritiesData: action.payload as ILookup[],
                isPrioritiesDataLoading: true
            };

        //  Replace full Project Type list
        case StoreAction.PROJECT_TYPES_DATA:
            return {
                ...state,
                projectTypesData: action.payload as ILookup[],
                isProjectTypesDataLoading: true
            };

        //  Replace full Action Project Type list
        case StoreAction.ACTION_PROJECT_TYPES_DATA:
            return {
                ...state,
                actionProjectTypesData: action.payload as ILookup[],
                isActionProjectTypesDataLoading: true
            };

        //  Replace full Jurisdiction list
        case StoreAction.JURISDICTION_DATA:
            return {
                ...state,
                jurisdictionData: action.payload as ILookup[],
                isJurisdictionDataLoading: true
            };

        // Replace full District list
        case StoreAction.DISTRICT_DATA:
            return {
                ...state,
                districtData: action.payload as IDistrict[],
                isDistrictDataLoading: true
            };    

        //  Replace full Municipality list
        case StoreAction.MUNICIPALITY_DATA:
            return {
                ...state,
                municipalityData: action.payload as IMunicipality[],
                isMunicipalityDataLoading: true
            };

        //  Replace full Programme list
        case StoreAction.PROGRAMMES_DATA:
            return {
                ...state,
                programmesData: action.payload as IProgramme[],
                isProgrammesDataLoading: true
            };

        case StoreAction.IDMS_PROJECT_STAGE_DATA:
            return {
                ...state,
                idmsProjectStageData: action.payload as ILookup[],
                isIdmsProjectStageDataLoading: true
            };

        case StoreAction.LOCATION_DATA:
            return {
                ...state,
                locationData: action.payload as ILocation[],
                isLocationDataLoading: true
            };

        default:
            return state;
    }
}
